<lex-doc-viewer-dialog>
    <div dialog-title>Edit {{title}}</div>
    <div dialog-body class="fontify-13px" style="overflow: auto; max-height: 350px; padding: 8px;">
        <div style=" gap: 8px;
        display: flex;
        flex-direction: column;">
            <div style="margin: 6px 2px; 
            align-self: center; 
            width: 85%;
            margin-right: 20px;">
            <textarea placeholder="Enter an email address and press Enter, or paste a list separated by semicolons." 
            (keydown)="onKeydown($event)"
            [(ngModel)]="emailInput"></textarea>
            </div>
            <div *ngIf="emails?.length > 0" class="list-container">
                <div style="margin:6px;">
                    <ng-container *ngFor="let email of emails; let last = last" >
                        <div class="item-row">
                            <div *ngIf="editItem!==email"
                                style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; width: 100%;">
                                <div style="white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;">{{email}}</div>
                                <div style="display:flex;">
                                    <lex-icon-button class="edit-button" [icon]="'fa-duotone fa-pen-to-square'" [background]="'none'" [type]="'action'"
                                        (click)="editItem=email"></lex-icon-button>
                                    <lex-icon-button [icon]="'fa-duotone fa-xmark'" [background]="'none'" [type]="'action'"
                                        (click)="removeEmail(email)"></lex-icon-button>
                                </div>
                            </div>
                            <div *ngIf="editItem===email" style="align-content: center; width: 100%;">
                                <lex-edit-input [value]="email" (setValue)="updateEmail($event, email)"
                                    (cancelValue)="editItem=null"></lex-edit-input>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div dialog-actions>
        <div style="display:flex; flex-direction: row; justify-content: flex-end; padding: 12px; gap: 4px;">
            <lex-flat-button (click)="ok()" [type]="'action'" label="Ok" class="center-button-text"></lex-flat-button>
            <lex-flat-button [type]="'action'" label="Cancel" matDialogClose></lex-flat-button>
        </div>
    </div>
</lex-doc-viewer-dialog>